import { Card, Col } from 'reactstrap'
import { Image } from '../../../../../AbstractElements'
import { dynamicImage } from '../../../../../Service'
import UserBlogDetails from './UserBlogDetails'

const UserBlog = () => {
  return (
    <Col xxl="6" className="xl-40 box-col-40">
      <Card>
        <div className="blog-box blog-shadow"> 
          <Image className="img-fluid" src={dynamicImage(`blog/blog.jpg`)} alt="blogImage" />
          <UserBlogDetails /> 
        </div>
      </Card>
    </Col>
  )
}

export default UserBlog